import { Component, inject, signal } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface VinLimitDialogData {
  max: number;
  /** The values that didn't fit, in the order they were pasted. */
  dropped: string[];
}

/** Lists the VINs a paste couldn't add because the lookup limit was reached. */
@Component({
  selector: 'app-vin-limit-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, ClipboardModule],
  templateUrl: './vin-limit-dialog.component.html',
  styleUrl: './vin-limit-dialog.component.scss'
})
export class VinLimitDialogComponent {
  readonly data = inject<VinLimitDialogData>(MAT_DIALOG_DATA);

  /** Comma-separated, the way the VIN input takes them — ready for a second search. */
  readonly copyText = this.data.dropped.join(', ');

  /** Set once the copy succeeds, so the button can confirm it. */
  readonly copied = signal(false);
}
